import { Row, Typography, Form, Space, Divider, Button } from 'antd';
import styled from 'styled-components';
import COLOR from './Colors';
import {
  BannerProps,
  DividerProps,
  GapRowProps,
  StyledFormProps,
  TextProps,
} from './StyledInterface';

const { Title, Paragraph, Text } = Typography;

export const Banner = styled.div`
  padding: ${(props: BannerProps) => props?.customPadding || '8px'};
  background: ${(props: BannerProps) => props?.customBackground || '#E9F5FF'};
  border: ${(props: BannerProps) => props?.customBorder || ''};
  border-radius: 8px;
`;

export const StyledTitle = styled(Title)`
  color: ${(props: TextProps) => props.color || COLOR.BLACK} !important;
  margin-bottom: ${(props: TextProps) => props.marginBottom || 0} !important;
  font-size: ${(props: TextProps) => `${props.fontSize || 14}px`} !important;
  font-weight: ${(props: TextProps) => props.fontWeight || 700} !important;
`;

export const PageTitle = styled(StyledTitle)`
  text-transform: capitalize;
`;

export const NormalText = styled(Paragraph)`
  color: ${(props: TextProps) => props.color || COLOR.BLACK} !important;
  margin-bottom: ${(props: TextProps) => props.marginBottom || 0} !important;
  font-size: ${(props: TextProps) => `${props.fontSize || 14}px`};
  line-height: ${(props: TextProps) =>
    props.fontSize ? `${props.fontSize + 8}px` : '22px'};
  font-weight: ${(props: TextProps) => props.fontWeight || '400'};
  align-self: ${(props: TextProps) => props.alignSelf || ''};
  text-align: ${(props: TextProps) => props.textAlign || ''};
  text-transform: ${(props: TextProps) => props.textTransform || ''};
`;

export const SmallText = styled(NormalText)`
  font-size: ${(props: TextProps) => props.fontSize || '10px'};
  line-height: ${(props: TextProps) =>
    props.fontSize ? `${props.fontSize + 6}px` : '16px'};
`;

export const NumericText = styled(Paragraph)`
  color: ${(props: TextProps) => props.color || COLOR.BLACK} !important;
  margin-bottom: ${(props: TextProps) => props.marginBottom || 0} !important;
  font-size: ${(props: TextProps) => `${props.fontSize || 14}px`};
  line-height: ${(props: TextProps) =>
    props.fontSize ? `${props.fontSize + 8}px` : '22px'};
  font-weight: ${(props: TextProps) => props.fontWeight || '400'};
  align-self: ${(props: TextProps) => props.alignSelf || ''};
  text-align: ${(props: TextProps) => props.textAlign || ''};
  text-transform: ${(props: TextProps) => props.textTransform || ''};
  font-family: 'Inconsolata';
`;

export const StyledGapRow = styled(Row)`
  gap: ${(props: GapRowProps) => `${props.gap || 4}px`};
`;

export const StyledColGapRow = styled(Row)`
  & > .ant-col {
    padding: ${(props: GapRowProps) => `${props.gap || 4}px`} !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    &:first-child {
      padding-left: 0px !important;
    }
    &:last-child {
      padding-right: 0px !important;
    }
  }
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: ${(props: StyledFormProps) => `${props.gap || 16}px`};

  .submit-button {
    padding: 5px 16px;
    border-radius: 4px;
    margin-top: 8px;
  }
`;

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 0px !important;

  .ant-form-item-row {
    gap: 4px;
    .ant-form-item-label {
      padding: 0;
      height: 24px !important;

      label {
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: ${COLOR.GRAY_10};
        text-transform: uppercase;

        .ant-form-item-optional {
          text-transform: lowercase;
        }
      }
    }
  }
  .ant-form-item-control {
    &-input {
      min-height: auto;
      .ant-select,
      .ant-input,
      .ant-input-password {
        border: 1px solid ${COLOR.GRAY_5} !important;
        border-radius: 4px !important;
      }
      .ant-select {
        .ant-select-selector {
          border: 0px !important;
          border-radius: inherit !important;
        }
      }
      .ant-input-password {
        .ant-input {
          border: 0px !important;
        }
      }
    }
    .ant-form-item-explain-error {
      font-size: 12px;
    }
  }
`;
export const StyledFormItemDefault = styled(Form.Item)`
  margin-bottom: 0px !important;

  .ant-form-item-row {
    gap: 4px;
    .ant-form-item-label {
      padding: 0;
      height: 24px !important;

      label {
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: ${COLOR.GRAY_10};
        .ant-form-item-optional {
          text-transform: lowercase;
        }
      }
    }
  }
  .ant-form-item-control {
    &-input {
      min-height: auto;
      .ant-select,
      .ant-input,
      .ant-input-password {
        border: 1px solid ${COLOR.GRAY_5} !important;
        border-radius: 4px !important;
      }
      .ant-select {
        .ant-select-selector {
          border: 0px !important;
          border-radius: inherit !important;
        }
      }
      .ant-input-password {
        .ant-input {
          border: 0px !important;
        }
      }
    }
    .ant-form-item-explain-error {
      font-size: 12px;
    }
  }
`;

export const StyledSpace = styled(Space)`
  width: 100%;
`;

export const StyledDivider = styled(Divider)`
  &.ant-divider {
    color: ${COLOR.GRAY_7} !important;
    border-top-color: ${COLOR.GRAY_4} !important;
    margin: 0 !important;

    .ant-divider-inner-text {
      font-weight: ${(props: DividerProps) => props.fontWeight || 700};
      font-size: 12px;
      line-height: 20px;
      text-transform: ${(props: DividerProps) =>
        props.texttransform || 'capitalize'};
    }
  }
`;

export const StyledLinkedButton = styled(Button)`
  padding: 0;
  border: 0;
  font-size: inherit;
`;

export const StyledText = styled(Text)`
  font-weight: 500;
  color: ${COLOR.GRAY_7};

  .value {
    color: ${COLOR.GRAY_8};
  }
`;
